import { FormControlLabel, Switch, Tooltip } from "@material-ui/core";
import React, { FC } from "react";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { useStyles } from "./styles";

interface SwitchProps {
  label: string;
  defaultStatus: boolean;
  handleSwitchToggle: (flag: boolean) => void;
  dataTestId?: string;
  infoTooltip?: string;
  switchTooltip?: string;
}

export const ControlledSwitch: FC<SwitchProps> = ({
  label,
  infoTooltip,
  switchTooltip,
  defaultStatus,
  handleSwitchToggle,
  dataTestId,
}) => {
  const styles = useStyles();
  
  const handleToggle = ({ target: { checked } }: React.ChangeEvent<HTMLInputElement>) => {
    handleSwitchToggle(checked);
  };

  return (
    <>
      <div className={styles.switchWrapper}>
        <FormControlLabel
          control={
            !switchTooltip ? (
              <Switch color="primary" checked={defaultStatus} onChange={handleToggle} />
            ) : (
              <Tooltip title={defaultStatus ? "" : switchTooltip} placement="top" arrow className={styles.tooltip}>
                <Switch color="primary" checked={defaultStatus} onChange={handleToggle} />
              </Tooltip>
            )
          }
          label={label}
          className={styles.switch}
          data-testid={dataTestId}
        />
        {infoTooltip && (
          <Tooltip title={infoTooltip} placement="top" arrow className={styles.tooltip}>
            <InfoOutlinedIcon data-testid="tooltip-cash_vs_burn_rate" fontSize="small" color="action" />
          </Tooltip>
        )}
      </div>
    </>
  );
};
